import moment from 'moment';
export const calendar = (date) => {
    return moment(date).calendar(undefined, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY'
    });
};
export const inTheFuture = (date) => {
    return moment(date).isAfter(moment());
};
export const inThePast = (date) => {
    return moment(date).isBefore(moment());
};
export const difference = (date, from = moment()) => {
    const diffTime = moment(date).diff(from);
    const duration = moment.duration(diffTime);
    return {
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds()
    };
};
//# sourceMappingURL=index.js.map